import { FileApiServices } from "../../../../services/api/FileServiceClient";
import { fileToBase64, getFileUrl, uploadFileWithSignedUrl } from "../../../../services/FilesService";
import store from "../../../../state/configureStore";
import webSocketClientApi from "../../../../services/socket/wsApiServices";

export const uploadingTheFile = async (
	file,
	conversationId,
	fileName,
	fileScope = null,
	scopeId
) => {

	const isOnline = store.getState().user.isOnline;
	const selectedDomain = store.getState().domain.selectedDomain;
	try {
		if (isOnline) {
			// await FileApiServices.uploadLargeFile({
			// 	file,
			// 	conversationId,
			// 	scopeId: scopeId || conversationId,
			// 	fileName,
			// 	fileScope,
			// });
			let payload = {
				// file: file,
				fileName,
				fileScope: fileScope || 'conversations',
				conversationId,
				scopeId: scopeId || conversationId,
				selectedDomain
			}
			const fileType = file.type
			webSocketClientApi.GetSignedUrlsForUpload(payload)
				.then((res) => {
					if (res?.signedFileUrl) {
						uploadFileWithSignedUrl(res?.signedFileUrl, file).then((response) => {
						const type = fileType.split("/")[0];
						if ((response.status === 200 || response.status === 201) && type==='video') {
							let payloadForThumbnail = {
								scopeId:scopeId || conversationId,
								fileName,
								fileScope: fileScope || 'conversations',
								"channelId": "",
								"selectedDomain": selectedDomain || '',
								"localContactUserId": "",
							}
							try {
								webSocketClientApi.CreateThumbnailForFile(payloadForThumbnail);

							} catch (error) {
								console.error("Error in creating thumbnail for video:", error);
							}
						}
					});
						
					}
				})
				.catch((error) => {
					console.error("Error in uploading group image", error);

				})
		} else {
			// Uncomment and implement queueFileUpload when offline support is ready
			// await queueFileUpload({
			//   file,
			//   conversationId,
			//   scopeId: conversationId,
			//   fileName,
			//   fileScope,
			// });
		}
		const fileUrl = await getFileUrl(conversationId, fileName);

		return fileUrl;
	} catch (error) {
		console.error("Error on upload", error);
		throw error;
	}
}
